import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

import { UserAuthLayout } from "../../components/user/UserAuthLayout";
import { Button } from "../../components/ui/button";
import { API_URL } from "../../config";
import { formatApiErrorDetail } from "../../context/UserAuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const hasRun = useRef(false);
  // Initial state computed synchronously from URL — avoids running setState
  // inside useEffect for the no-token branch.
  const [state, setState] = useState(token ? "loading" : "error");
  const [errorMsg, setErrorMsg] = useState(token ? "" : "Link inválido (sem token).");

  useEffect(() => {
    if (!token) return;
    if (hasRun.current) return;
    hasRun.current = true;
    (async () => {
      try {
        await axios.post(`${API_URL}/api/users/verify-email`, { token });
        setState("success");
      } catch (err) {
        setState("error");
        setErrorMsg(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao confirmar email.");
      }
    })();
  }, [token]);

  if (state === "loading") {
    return (
      <UserAuthLayout title="A confirmar email...">
        <div className="py-6 text-center" data-testid="verify-loading">
          <Loader2 className="w-8 h-8 animate-spin text-amber-400 mx-auto" />
        </div>
      </UserAuthLayout>
    );
  }

  if (state === "success") {
    return (
      <UserAuthLayout title="Email confirmado">
        <div className="text-center py-4" data-testid="verify-success">
          <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-3" />
          <p className="text-zinc-300 mb-6">O seu email foi confirmado com sucesso. Obrigado!</p>
          <Link to="/conta" className="btn-primary inline-block">Aceder à Minha Conta</Link>
        </div>
      </UserAuthLayout>
    );
  }

  return (
    <UserAuthLayout title="Não foi possível confirmar">
      <div className="text-center py-4" data-testid="verify-error">
        <XCircle className="w-14 h-14 text-red-400 mx-auto mb-3" />
        <p className="text-zinc-300 mb-4">{errorMsg}</p>
        <p className="text-zinc-500 text-sm mb-6">Pode pedir um novo email de confirmação a partir da sua conta.</p>
        <div className="flex flex-col gap-2 items-center">
          <Link to="/conta" className="btn-primary inline-block w-full text-center">Ir para Minha Conta</Link>
          <Link to="/login" className="text-amber-400 hover:text-amber-300 text-sm">Entrar primeiro</Link>
        </div>
      </div>
    </UserAuthLayout>
  );
}
